"use strict";

var _regeneratorRuntime = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClickPreventionOnDoubleClick = void 0;

var react_1 = require("react");

var cancellable_promise_1 = require("./cancellable-promise");

var delay_1 = require("./delay");

var use_cancellable_promises_1 = require("./use-cancellable-promises");

var useClickPreventionOnDoubleClick = function useClickPreventionOnDoubleClick(onClick, onDoubleClick, doubleClickToFullscreen) {
  var api = (0, use_cancellable_promises_1.useCancellablePromises)();
  var handleClick = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var waitForClick, info;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api.clearPendingPromises();
              waitForClick = (0, cancellable_promise_1.cancellablePromise)((0, delay_1.delay)(200));
              api.appendPendingPromise(waitForClick);
              _context.prev = 3;
              _context.next = 6;
              return waitForClick.promise;

            case 6:
              api.removePendingPromise(waitForClick);
              onClick(e);
              _context.next = 16;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              info = _context.t0;
              api.removePendingPromise(waitForClick);

              if (info.isCanceled) {
                _context.next = 16;
                break;
              }

              throw info.error;

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [api, onClick]);
  var handleDoubleClick = (0, react_1.useCallback)(function () {
    api.clearPendingPromises();
    onDoubleClick();
  }, [api, onDoubleClick]);
  var returnValue = (0, react_1.useMemo)(function () {
    if (!doubleClickToFullscreen) {
      return [onClick, onDoubleClick];
    }

    return [handleClick, handleDoubleClick];
  }, [doubleClickToFullscreen, handleClick, handleDoubleClick, onClick, onDoubleClick]);
  return returnValue;
};

exports.useClickPreventionOnDoubleClick = useClickPreventionOnDoubleClick;